module.exports = __webpack_public_path__ + "static/img/render2-thumb.c7da9a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/render2-thumb.jpg
// module id = 3C70
// module chunks = 0